module.exports = __webpack_public_path__ + "static/media/mecanicoDelivery.ae24bb65.svg";